import type { ConnectEmailMethod } from '@/constants';
import { LoginMethod } from '@/interfaces';
import type { GtmPopupParams } from './gtmTracking';

export type SignUpSuccessArgs = GtmPopupParams & {
  // reply flag: `created` (popup/landing) or `first_verified` (/verify); missing = no
  isNewAccount?: boolean;
  // `emailSyncOptIn` of the login reply; only counts for Google logins
  emailSyncOptIn?: boolean;
};

export type ConnectEmailSuccessArgs = {
  method: ConnectEmailMethod;
  // reply `ems_first_grant`; missing = no
  emsFirstGrant?: boolean;
  variant?: string;
};

const toYesNo = (value: boolean) => (value ? 'yes' : 'no');

export const buildSignUpSuccessParams = ({
  authenticationMethod,
  click,
  delayTime,
  cta,
  variant,
  popupVariant,
  isNewAccount,
  emailSyncOptIn,
}: SignUpSuccessArgs) => ({
  authenticationMethod,
  click,
  delayTime: click ? undefined : delayTime,
  cta,
  variant,
  popupVariant,
  email_granted: toYesNo(authenticationMethod === LoginMethod.Google && emailSyncOptIn === true),
  is_new_account: toYesNo(isNewAccount === true),
});

export const buildConnectEmailSuccessParams = ({ method, variant, emsFirstGrant }: ConnectEmailSuccessArgs) => ({
  method,
  variant,
  is_new_ems: toYesNo(emsFirstGrant === true),
});

// Statsig metadata: same keys as the GA4 object, every value a string, undefined/null -> ''
export const normaliseForStatsig = (params: Record<string, unknown>): Record<string, string> =>
  Object.fromEntries(Object.entries(params).map(([key, value]) => [key, value == null ? '' : String(value)]));
